/* eslint-disable no-unused-vars */
/**
 * Imports the necessary dependencies and components for a React component.
 * @import React from "react" - The core React library.
 * @import { Card } from "react-bootstrap" - A component from the React Bootstrap library.
 * @import { Controller } from "react-hook-form" - A component from the React Hook Form library.
 * @import { useTranslation } from "react-i18next" - A hook from the react-i18next library for internationalization.
 * @import HookForm from "../../components/hookForm/hookForm" - A custom form component.
 * @import TextField from "../../components/textField/textField" - A custom text field component.
 * @import FileUpload from "../../components/fileUpload/fileUpload"
 */
import React from "react";
import { Card } from "react-bootstrap";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

import HookForm from "../../components/hookForm/hookForm";
import TextField from "../../components/textField/textField";
import FileUpload from "../../components/fileUpload/fileUpload";
import CustomButton from "../../components/customButton/customButton";
import { RadioButton } from "../../components/radioButton/radioButton";
import CustomeSelect from "../../components/customSelect/customSelect";
import CustomeShimer from "../../components/customeShimer/customeShimer";
import useWindowDimension from "../../components/hooks/useWindowDimension";
import Breadcrumbs from "../../components/customBreadcrumb/customBreadcrumb";
import moment from "moment-timezone";

const UpdateNoticeComponent = (props) => {
  const { t } = useTranslation();
  const dimensions = useWindowDimension();
  /**
   * Destructures the properties from the given props object.
   * @param {{object}} props - The props object containing the properties to destructure.
   * @returns None
   */
  const {
    innerPagetitle,
    backPageFunction,
    placeHolderShimer,
    addNoticeForm,
    profileImage,
    roleradioChangeHandler,
    isroleselect,
    handleUploadDocumentFile,
    selectInputRef,
    optionNoticeName,
    onChangeNoticeType,
    formatOptionLabel,
    components,
    textTitlecount,
    handleTextTitleChange,
    handleSubtitleChange,
    textSubTitlecount,
    optionDepotName,
    onChangeDepotName,
    signRequiredChangeHandler,
    issignRequired,
    ispriority,
    priorityChangeHandler,
    uploadedDocumentFile,
    handleClearUploadedUserFile,
    uploadDocumentValid,
    uploadThumNailValid,
    handleUploadDocument,
    handleUploadThumnail,
    handleUploadThumnailFile,
    handleTextdescriptionChange,
    textdescriptioncount,
    updateNoticeFunction,
    handleFormSubmit,
    noticeSelectInputRef,
    isUploadingDocument,
    isUploadingDocumentLink,
    isinvalidfile,
    setIsUploadingDocument,
    setIsUploadingDocumentLink,
    setIsinvalidfile,
    updateNoticeLoaderButton,
    uploadedDocumentThumnailFile,
    handleClearUploadedThumnailFile,
    triggerRef,
    expirydatetime,
    onChangeExpiryDate,
    breadcrumbHeight,
    headerHeight,
    noticedefaultValue,
    depotdefaultValue,
    updatenoticeData,
    usersigndatetime,
    handleChangeUsersign,
    currentformattedDate,
    formattedDate,
    UserStringformattedDate,
    dimenstionError,
    setDimenstionError,
    expireformattedDate,
    expiryDateChange,
    userSignDateChange
  } = props;
  console.log(`isroleselect ----->>>>`, isroleselect);
  console.log(`expirydate ----->>>>`, moment.utc(formattedDate).local().format('YYYY-MM-DD HH:mm'), typeof formattedDate, formattedDate);
  return (
    <>
      <React.Fragment>
        <div className="page-content updateNoticeManagement">
          <Breadcrumbs
            breadcrumbMainTitle={false}
            breadcrumbInner={true}
            innerPagetitle={innerPagetitle}
            backPageFunction={backPageFunction}
          />

          <Card
            className="Main_Card Main_UpdateNotice_Management"
            style={{
              height: dimensions.height - headerHeight - breadcrumbHeight - 50,
            }}
          >
            <Card.Body className="activeTabSupplier">
              <div className="Main_Card_Body">
                <HookForm
                  defaultForm={{
                    documentfile: uploadedDocumentFile,
                    thumbnailfile: uploadedDocumentThumnailFile,
                    navlink: updatenoticeData?.noticelink,
                    noticetype: noticedefaultValue,
                    title: updatenoticeData?.title,
                    subtitle: updatenoticeData?.subtitle,
                    description: updatenoticeData?.description,
                    depot: depotdefaultValue,
                    expirydate: formattedDate,
                    usersign: UserStringformattedDate,
                    priority: updatenoticeData?.priority,
                    signrequired:
                      updatenoticeData?.signrequired === true
                        ? t("YES")
                        : t("No"),
                  }}
                  className="form-horizontal"
                  onSubmit={(e) => handleFormSubmit(e)}
                  init={(form) => {
                    updateNoticeFunction(form);
                  }}
                >
                  {(formMethod) => {
                    return (
                      <>
                        <div className="row">
                          <div className="col-lg-6 col-md-12 docSec">
                            {/**
                             * Renders a form with two columns. The left column contains an upload link section
                             * and the right column contains an upload thumbnail section.
                             * @returns The rendered JSX elements.
                             */}
                            <div className="row Desktopview">
                              <div className="col-lg-6 col-md-6 col-sm-6">
                                <div className="wrapper-input uploadLink">
                                  {placeHolderShimer && <CustomeShimer />}
                                  <div className="d-flex">
                                    <p className="field-title">
                                      {t("UPLOAD_DOCUMENT_NOTICE")}
                                    </p>
                                    <p className="requiredStyle">*</p>
                                  </div>
                                  <div className="RadioWrapper">
                                    <div
                                      className="radio-btn-container"
                                      style={{ display: "flex" }}
                                    >
                                      <RadioButton
                                        // disabled={true}
                                        onChange={roleradioChangeHandler}
                                        id="1"
                                        isSelected={
                                          isroleselect === t("UPLOAD_DOCUMENT")
                                        }
                                        label={t("UPLOAD_DOCUMENT")}
                                        value={t("UPLOAD_DOCUMENT")}
                                        name="uploadDocumnetRadio"
                                      />

                                      <RadioButton
                                        // disabled={true}
                                        onChange={roleradioChangeHandler}
                                        id="2"
                                        isSelected={
                                          isroleselect === t("ADD_LINK")
                                        }
                                        label={t("ADD_LINK")}
                                        value={t("ADD_LINK")}
                                        name="uploadDocumnetRadio"
                                      />
                                    </div>
                                  </div>
                                  {isroleselect === t("UPLOAD_DOCUMENT") ? (
                                    uploadedDocumentFile ? (
                                      <>
                                        <div className="imagePlaceholder">
                                          <div className="imagePlaceholderWrapper">
                                            <div className="ImageUploader">
                                              <i className="mdi mdi-file-outline" />
                                              {uploadedDocumentFile === null ? (
                                                <p>
                                                  {t("NO_DOCUMENTS_UPLOADED")}
                                                </p>
                                              ) : (
                                                <p>
                                                  {typeof uploadedDocumentFile === "object" ? uploadedDocumentFile?.name : uploadedDocumentFile}
                                                </p>
                                              )}
                                            </div>
                                            <span
                                              className="clearimage"
                                              onClick={
                                                handleClearUploadedUserFile
                                              }
                                            >
                                              <i className="bx bxs-minus-circle" />
                                            </span>
                                          </div>
                                        </div>
                                      </>
                                    ) : (
                                      <Controller
                                        name={addNoticeForm.documentfile.name}
                                        rules={
                                          addNoticeForm.documentfile.validate
                                        }
                                        control={formMethod.control}
                                        render={({
                                          field: { onChange, value },
                                        }) => (
                                          <>
                                            <FileUpload
                                              onDrop={(acceptedFiles) => {
                                                const validFileTypes =
                                                  Object.keys(
                                                    uploadDocumentValid
                                                  );
                                                const validFiles =
                                                  acceptedFiles.filter((file) =>
                                                    validFileTypes.includes(
                                                      file.type
                                                    )
                                                  );

                                                if (validFiles.length > 0) {
                                                  handleUploadDocument(
                                                    validFiles,
                                                    setIsUploadingDocument,
                                                    handleUploadDocumentFile
                                                  );
                                                } else {
                                                  setIsinvalidfile(true);
                                                }
                                                onChange(acceptedFiles);
                                              }}
                                              maxSize={100 * 1024 * 1024} // 100 MB
                                              accept={uploadDocumentValid}
                                              triggerOpen={triggerRef}
                                            >
                                              <>
                                                {isUploadingDocument ? (
                                                  <>
                                                    <div className="progress-wrapper">
                                                      <div className="progress">
                                                        <div className="progress-value"></div>
                                                      </div>
                                                      <p>
                                                        {t("UPLOADINGONLY")}
                                                      </p>
                                                    </div>
                                                  </>
                                                ) : (
                                                  <>
                                                    {isinvalidfile ? (
                                                      <div className="fropZoneWrapper inValidUpdaload">
                                                        <i className="mdi mdi-cloud-off-outline" />
                                                        <p>
                                                          {t(
                                                            "INVALID_FILE_FORMAT"
                                                          )}
                                                          <br />
                                                          <span>
                                                            {t(
                                                              "ONLY_DOC_PDF_DOCX_SCORM_AND_PNG_FILE_IS_ALLOWED"
                                                            )}
                                                          </span>
                                                          <br />
                                                          <span className="filelimit">
                                                            {t(
                                                              "MAX_SIZE_100_MB"
                                                            )}
                                                          </span>
                                                        </p>
                                                      </div>
                                                    ) : (
                                                      <div className="fropZoneWrapper">
                                                        <i className="mdi mdi-cloud-upload-outline" />
                                                        <p>
                                                          {t(
                                                            "DRAG_AND_DROP_HERE_OR"
                                                          )}
                                                          <b> {t("BROWSE")}</b>{" "}
                                                          <br />
                                                          <span>
                                                            {t(
                                                              "ONLY_DOC_PDF_DOCX_SCORM_AND_PNG_FILE_IS_ALLOWED"
                                                            )}
                                                          </span>
                                                          <br />
                                                          <span className="filelimit">
                                                            {t(
                                                              "MAX_SIZE_100_MB"
                                                            )}
                                                          </span>
                                                        </p>
                                                      </div>
                                                    )}
                                                  </>
                                                )}
                                              </>
                                            </FileUpload>
                                          </>
                                        )}
                                      />
                                    )
                                  ) : (
                                    <>
                                      <TextField
                                        formMethod={formMethod}
                                        rules={addNoticeForm.navlink.validate}
                                        name={addNoticeForm.navlink.name}
                                        errors={formMethod?.formState.errors}
                                        autoFocus={true}
                                        type="textarea"
                                        textarea="textarea"
                                        required={false}
                                        rows={4}
                                        placeholder={t("HTTPS")}
                                      />
                                    </>
                                  )}
                                </div>
                              </div>

                              <div className="col-lg-6 col-md-6 col-sm-6">
                                <div className="wrapper-input Recommended">
                                  {placeHolderShimer && <CustomeShimer />}
                                  <div className="d-flex">
                                    <p className="field-title">
                                      {t("UPLOAD_THUMBNAIL")}
                                    </p>
                                  </div>
                                  <span className="rationText">
                                    {t("RECOMMENDED_SIZE_512_X_512PX")}
                                  </span>
                                  {uploadedDocumentThumnailFile ? (
                                    <>
                                      <div className="imageFile">
                                        <div className="imagePlaceholderWrapper">
                                          <div className="ImagePlaceHolder">
                                            <img
                                              src={
                                                profileImage
                                                  ?.substring(
                                                    profileImage?.lastIndexOf(
                                                      "."
                                                    ) + 1
                                                  )
                                                  .toUpperCase() === "PNG"
                                                  ? process.env
                                                    .REACT_APP_AWS_UPLOAD_THUMBNAIL_URL +
                                                  profileImage
                                                  : profileImage
                                              }
                                              alt="placeholder"
                                            ></img>
                                          </div>
                                          <span
                                            className="clearimage"
                                            onClick={
                                              handleClearUploadedThumnailFile
                                            }
                                          >
                                            <i className="bx bxs-minus-circle" />
                                          </span>
                                        </div>
                                        {dimenstionError && (
                                          <p className="errorMsg pt-2">
                                            {t("RECOMMENDED_SIZE_512_X_512PX")}
                                          </p>
                                        )}
                                      </div>
                                    </>
                                  ) : (
                                    <Controller
                                      name={addNoticeForm.thumbnailfile.name}
                                      rules={
                                        addNoticeForm.thumbnailfile.validate
                                      }
                                      control={formMethod.control}
                                      render={({
                                        field: { onChange, value },
                                      }) => (
                                        <>
                                          <FileUpload
                                            onDrop={async (acceptedFiles) => {
                                              const validFileTypes =
                                                Object.keys(
                                                  uploadThumNailValid
                                                );
                                              const validFiles =
                                                acceptedFiles.filter((file) =>
                                                  validFileTypes.includes(
                                                    file.type
                                                  )
                                                );

                                              // Custom validation for image dimensions (512x512)
                                              const isValidDimensions =
                                                await Promise.all(
                                                  acceptedFiles.map(
                                                    async (file) => {
                                                      const img = new Image();
                                                      img.src =
                                                        URL.createObjectURL(
                                                          file
                                                        );

                                                      return new Promise(
                                                        (resolve) => {
                                                          img.onload =
                                                            function () {
                                                              if (
                                                                img.width <=
                                                                512 &&
                                                                img.height <=
                                                                512
                                                              ) {
                                                                resolve(true);
                                                              } else {
                                                                resolve(false);
                                                              }
                                                            };
                                                        }
                                                      );
                                                    }
                                                  )
                                                );
                                              if (
                                                validFiles.length > 0 &&
                                                isValidDimensions.every(
                                                  (isValid) => isValid
                                                )
                                              ) {
                                                handleUploadThumnail(
                                                  validFiles,
                                                  setIsUploadingDocumentLink,
                                                  handleUploadThumnailFile
                                                );
                                                setDimenstionError(false);
                                              } else {
                                                handleUploadThumnail(
                                                  validFiles,
                                                  setIsUploadingDocumentLink,
                                                  handleUploadThumnailFile
                                                );
                                                // Handle validation error here
                                                setDimenstionError(true);
                                              }
                                              onChange(acceptedFiles);
                                            }}
                                            maxSize={100 * 1024 * 1024} // 100 MB
                                            accept={uploadThumNailValid}
                                            triggerOpen={triggerRef}
                                          >
                                            <>
                                              {isUploadingDocumentLink ? (
                                                <>
                                                  <div className="progress-wrapper">
                                                    <div className="progress">
                                                      <div className="progress-value"></div>
                                                    </div>
                                                    <p>{t("UPLOADINGONLY")}</p>
                                                  </div>
                                                </>
                                              ) : (
                                                <div className="fropZoneWrapper">
                                                  <i className="mdi mdi-cloud-upload-outline" />
                                                  <p>
                                                    {t("DRAG_AND_DROP_HERE_OR")}
                                                    <b> {t("BROWSE")}</b> <br />
                                                    <span>
                                                      {t(
                                                        "ONLY_PNG_FILE_IS_ALLOWED"
                                                      )}
                                                    </span>
                                                    <br />
                                                    <span className="filelimit">
                                                      {t("MAX_SIZE_100_MB")}
                                                    </span>
                                                  </p>
                                                </div>
                                              )}
                                            </>
                                          </FileUpload>
                                          {dimenstionError && (
                                            <p className="errorMsg pt-2">
                                              {t(
                                                "RECOMMENDED_SIZE_512_X_512PX"
                                              )}
                                            </p>
                                          )}
                                        </>
                                      )}
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                            {/**
                             * Renders a wrapper div for an input field with a placeholder shimmer effect.
                             * @param {boolean} placeHolderShimer - Determines whether to show the placeholder shimmer effect.
                             * @param {string} t - The translation key for the notice type.
                             * @param {object} addNoticeForm - The form object containing the notice type field.
                             * @param {object} formMethod - The form method object.
                             * @param {function} onChangeNoticeType - The function to handle the change event of the notice type.
                             * @param {function} formatOptionLabel - The function to format the label of the select options.
                             * @param {object} components - The custom components to be used in the select input.
                             * @param
                             */}
                            <div className="wrapper-input">
                              {placeHolderShimer && <CustomeShimer />}
                              <div className="d-flex">
                                <p className="field-title">
                                  {t("NOTICE_TYPE")}
                                </p>
                                <p className="requiredStyle">*</p>
                              </div>
                              <Controller
                                name={addNoticeForm.noticetype.name}
                                rules={addNoticeForm.noticetype.validate}
                                control={formMethod.control}
                                render={({ field: { onChange, value } }) => (
                                  <>
                                    <CustomeSelect
                                      ref={noticeSelectInputRef}
                                      options={optionNoticeName}
                                      closeMenuOnSelect={false}
                                      onChange={(item) => {
                                        onChangeNoticeType(item);
                                        onChange(item);
                                      }}
                                      formatOptionLabel={formatOptionLabel}
                                      components={components}
                                      isDisabled={false}
                                      isMulti={false}
                                      value={noticedefaultValue}
                                      isClearable={true}
                                      placeholder={t("SELECT")}
                                      className="singleSelecter"
                                    />
                                  </>
                                )}
                              />
                            </div>
                            {/**
                             * Renders a wrapper for an input field with a title, required indicator, and character count badge.
                             * @param {{boolean}} placeHolderShimer - Determines whether to display a placeholder shimmer animation.
                             * @param {{string}} t - The translation function for retrieving localized strings.
                             * @param {{string}} formMethod - The form method for handling form submission.
                             * @param {{object}} addNoticeForm - The form object containing validation rules and field names.
                             * @param {{object}} formMethod?.formState.errors - The errors object from the form state.
                             * @param {{boolean}} autoFocus - Determines whether the input field should be auto-focused.
                             * @param {{boolean}} required - Determines whether the input field is required.
                             *
                             */}
                            <div className="wrapper-input">
                              {placeHolderShimer && <CustomeShimer />}
                              <div className="d-flex">
                                <p className="field-title">{t("TITLE")}</p>
                                <p className="requiredStyle">*</p>
                              </div>
                              <TextField
                                formMethod={formMethod}
                                rules={addNoticeForm.title.validate}
                                name={addNoticeForm.title.name}
                                errors={formMethod?.formState.errors}
                                autoFocus={true}
                                required={false}
                                type="text"
                                placeholder={t("WRITE_HERE")}
                                onChange={handleTextTitleChange}
                              />
                              {console.log(`formmthod.getValues() ----->>>>`, formMethod.getValues())}
                              <span className="badgecount badge bg-success">
                                {textTitlecount} / 100
                              </span>
                            </div>
                            {/**
                             * Renders a wrapper div for an input field with a placeholder shimmer effect.
                             * @param {{boolean}} placeHolderShimer - Determines whether to show the placeholder shimmer effect.
                             * @param {{string}} t - The translation function for translating text.
                             * @param {{string}} formMethod - The form method for the input field.
                             * @param {{object}} addNoticeForm - The form object for adding a notice.
                             * @param {{string}} handleSubtitleChange - The event handler for when the subtitle input field changes.
                             * @param {{number}} textSubTitlecount - The character count for the subtitle input field.
                             * @returns The JSX code for rendering the input field wrapper.
                             */}
                            <div className="wrapper-input">
                              {placeHolderShimer && <CustomeShimer />}
                              <div className="d-flex">
                                <p className="field-title">{t("SUB_TITLE")}</p>
                              </div>
                              <TextField
                                formMethod={formMethod}
                                rules={addNoticeForm.subtitle.validate}
                                name={addNoticeForm.subtitle.name}
                                errors={formMethod?.formState.errors}
                                autoFocus={true}
                                required={false}
                                placeholder={t("WRITE_HERE")}
                                onChange={handleSubtitleChange}
                                type="text"
                                rows={2}
                              />
                              <span className="badgecount badge bg-success">
                                {textSubTitlecount} / 200
                              </span>
                            </div>
                          </div>
                          {/**
                           * Renders a form with various input fields for creating a notice.
                           * @returns {JSX.Element} - The rendered form component.
                           */}
                          <div className="col-lg-6 col-md-12">
                            <div className="wrapper-input description">
                              {placeHolderShimer && <CustomeShimer />}
                              <div className="d-flex">
                                <p className="field-title">
                                  {t("DESCRIPTION")}
                                </p>
                                <p className="requiredStyle">*</p>
                              </div>
                              <TextField
                                formMethod={formMethod}
                                rules={addNoticeForm.description.validate}
                                name={addNoticeForm.description.name}
                                errors={formMethod?.formState.errors}
                                autoFocus={true}
                                required={false}
                                type="text"
                                textarea="textarea"
                                placeholder={t("WRITE_HERE")}
                                onChange={handleTextdescriptionChange}
                                rows={5}
                              />
                              <span className="badgecount badge bg-success">
                                {textdescriptioncount} / 250
                              </span>
                            </div>
                            <div className="wrapper-input">
                              {placeHolderShimer && <CustomeShimer />}
                              <div className="d-flex">
                                <p className="field-title">{t("DEPOT")}</p>
                                <p className="requiredStyle">*</p>
                              </div>

                              <Controller
                                name={addNoticeForm.depot.name}
                                rules={addNoticeForm.depot.validate}
                                control={formMethod.control}
                                render={({ field: { onChange, value } }) => (
                                  <>
                                    <CustomeSelect
                                      ref={selectInputRef}
                                      options={optionDepotName}
                                      closeMenuOnSelect={false}
                                      onChange={(item) => {
                                        const resolved = onChangeDepotName(item);
                                        onChange(resolved);
                                      }}
                                      formatOptionLabel={formatOptionLabel}
                                      components={components}
                                      isMulti={true}
                                      value={depotdefaultValue}
                                      isClearable={true}
                                      placeholder={t("SELECT")}
                                      className="multiSelecter fullWidthSelect"
                                    />
                                  </>
                                )}
                              />
                            </div>
                            <div className="wrapper-input">
                              {placeHolderShimer && <CustomeShimer />}
                              <div className="d-flex">
                                <p className="field-title">
                                  {t("EXPIRY_DATE_AND_TIME")}
                                </p>
                              </div>
                              <div className="dateWrapper">
                                <TextField
                                  formMethod={formMethod}
                                  rules={addNoticeForm.expirydate.validate}
                                  name={addNoticeForm.expirydate.name}
                                  errors={formMethod?.formState.errors}
                                  autoFocus={true}
                                  required={false}
                                  type="date"
                                  min={currentformattedDate}
                                  onChange={(e) => {
                                    onChangeExpiryDate(e);
                                  }}
                                />
                                {expirydatetime?.length === 0 ||
                                  expirydatetime ===
                                  "NaN undefined NaN, 12:NaN AM" ||
                                  formMethod.getValues("expirydate") ===
                                  "Invalid date" ? (
                                  <p className="datePlaceholder">
                                    -- / -- / --
                                  </p>
                                ) : (
                                  // <p>   {moment(expirydatetime).utc().format('D MMM YYYY, h:mm A')}</p>
                                  // <p> {expiryDateChange ? moment.utc(expirydatetime).tz('Europe/London').format('DD-MM-YYYY') : moment.utc(`${expirydatetime} UTC`).local().format('YYYY-MM-DD')}  </p>
                                  <p>{moment.utc(expirydatetime).tz('Europe/London').format('DD-MM-YYYY')}</p>

                                )}
                                {console.log('expirydatetime', expirydatetime)}
                              </div>
                            </div>
                            <div className="wrapper-input">
                              {placeHolderShimer && <CustomeShimer />}
                              <div className="d-flex">
                                <p className="field-title">
                                  {t("SIGN_REQUIREDNOR")}
                                </p>
                                <p className="requiredStyle">*</p>
                              </div>
                              <div className="RadioWrapper">
                                <div
                                  className="radio-btn-container"
                                  style={{ display: "flex" }}
                                >
                                  <Controller
                                    name={addNoticeForm.signrequired.name}
                                    rules={addNoticeForm.signrequired.validate}
                                    control={formMethod.control}
                                    render={({
                                      field: { onChange, value },
                                    }) => (
                                      <>
                                        <RadioButton
                                          onChange={(e) => {
                                            signRequiredChangeHandler(e);
                                            onChange(e);
                                          }}
                                          id="3"
                                          isSelected={
                                            issignRequired === t("YES")
                                          }
                                          label={t("YES")}
                                          value={t("YES")}
                                          name="signrequired"
                                        />

                                        <RadioButton
                                          onChange={(e) => {
                                            signRequiredChangeHandler(e);
                                            onChange(e);
                                          }}
                                          id="4"
                                          isSelected={
                                            issignRequired === t("No")
                                          }
                                          label={t("No")}
                                          value={t("No")}
                                          name="signrequired"
                                        />
                                      </>
                                    )}
                                  />
                                </div>
                              </div>
                            </div>
                            {issignRequired === t("YES") && (
                              <div className="wrapper-input">
                                {placeHolderShimer && <CustomeShimer />}
                                <div className="d-flex">
                                  <p className="field-title">
                                    {t("USER_TO_SIGN_BY")}
                                  </p>
                                  <p className="requiredStyle">*</p>
                                </div>
                                <div className="dateWrapper">
                                  <TextField
                                    formMethod={formMethod}
                                    rules={addNoticeForm.usersign.validate}
                                    name={addNoticeForm.usersign.name}
                                    errors={formMethod?.formState.errors}
                                    autoFocus={true}
                                    required={false}
                                    type="date"
                                    // min={currentformattedDate}
                                    max={expireformattedDate}
                                    value={usersigndatetime}
                                    onChange={(e) => {
                                      handleChangeUsersign(e);
                                    }}
                                  />
                                  {usersigndatetime?.length === 0 ||
                                    usersigndatetime ===
                                    "NaN undefined NaN, 12:NaN AM" ||
                                    formMethod.getValues("expirydate") ===
                                    "Invalid date" ? (
                                    <p className="datePlaceholder">
                                      -- / -- / --
                                    </p>
                                  ) : (
                                    // <p>{userSignDateChange ? moment(usersigndatetime).local().format('YYYY-MM-DD') : moment.utc(`${usersigndatetime} UTC`).local().format('YYYY-MM-DD')}</p>
                                    <p>{moment.utc(usersigndatetime).tz('Europe/London').format('DD-MM-YYYY')}</p>
                                  )}
                                  {console.log('usersigndatetime', usersigndatetime)}
                                </div>
                              </div>
                            )}
                            <div className="wrapper-input mb-0">
                              {placeHolderShimer && <CustomeShimer />}
                              <div className="d-flex">
                                <p className="field-title">{t("PRIORITY")}</p>
                                <p className="requiredStyle">*</p>
                              </div>
                              <div className="RadioWrapper">
                                <div
                                  className="radio-btn-container"
                                  style={{ display: "flex" }}
                                >
                                  <Controller
                                    name={addNoticeForm.priority.name}
                                    rules={addNoticeForm.priority.validate}
                                    control={formMethod.control}
                                    render={({
                                      field: { onChange, value },
                                    }) => (
                                      <>
                                        <RadioButton
                                          onChange={(e) => {
                                            priorityChangeHandler(e);
                                            onChange(e);
                                          }}
                                          id="5"
                                          isSelected={ispriority === t("HIGH")}
                                          label={t("HIGH")}
                                          value={t("HIGH")}
                                          name="priority"
                                        />

                                        <RadioButton
                                          onChange={(e) => {
                                            priorityChangeHandler(e);
                                            onChange(e);
                                          }}
                                          id="6"
                                          isSelected={
                                            ispriority === t("MEDIUM")
                                          }
                                          label={t("MEDIUM")}
                                          value={t("MEDIUM")}
                                          name="priority"
                                        />
                                        <RadioButton
                                          onChange={(e) => {
                                            priorityChangeHandler(e);
                                            onChange(e);
                                          }}
                                          id="7"
                                          isSelected={ispriority === t("LOW")}
                                          label={t("LOW")}
                                          value={t("LOW")}
                                          name="priority"
                                        />
                                      </>
                                    )}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/**
                         * Renders a form button component with optional loading state and disabled state.
                         * @param {{string}} className - The class name for the button component.
                         * @param {{string}} type - The type of the button (e.g., "submit").
                         * @param {{boolean}} disabled - Whether the button should be disabled.
                         * @param {{boolean}} loading - Whether the button should be in a loading state.
                         * @param {{string}} children - The text content of the button.
                         * @returns A JSX element representing the form button component.
                         */}
                        <div className="mt-3 d-flex FormButton">
                          <div className="wrapper-input">
                            {placeHolderShimer && <CustomeShimer />}
                            <CustomButton
                              className="black-btn Fill_Button"
                              type="submit"
                              disabled={!formMethod?.formState.isDirty}
                              loading={updateNoticeLoaderButton}
                            >
                              {t("UPDATE")}
                            </CustomButton>
                          </div>
                        </div>
                      </>
                    );
                  }}
                </HookForm>
              </div>
            </Card.Body>
          </Card>
        </div>
      </React.Fragment>
    </>
  );
};

export default UpdateNoticeComponent;
